import React from 'react'

import { useAppSelector } from '@/stores/hooks.ts'
import { ToCStatusFilter } from '@/pages/sbp-payments/sbp-payments-filters/status-filter/to-c-status-filter.tsx'
import { ToBStatusFilter } from '@/pages/sbp-payments/sbp-payments-filters/status-filter/to-b-status-filter.tsx'

export const StatusFilter = (): React.ReactElement => {
  const sbpType = useAppSelector((state) => state.sbpPayments.sbpType)

  return sbpType === 'B2C' ? <ToCStatusFilter /> : <ToBStatusFilter />
}
